import React from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

export default function Accordion({ title, children, defaultOpen = false, className = '' }) {
  return (
    <div className={className}>
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <DisclosureButton className="flex w-full justify-between items-center rounded-lg bg-gray-800/50 px-4 py-3 text-left text-sm font-medium text-white hover:bg-gray-800 focus:outline-none focus-visible:ring focus-visible:ring-indigo-500/75 transition-colors duration-200 cursor-pointer">
              <span className="tracking-wider text-xs text-gray-400 group-hover:text-gray-300">
                {title}
              </span>
              <ChevronDownIcon
                className={classNames(
                  open ? 'rotate-180 transform' : '',
                  'h-4 w-4 text-gray-400 transition-transform duration-200 ease-in-out'
                )}
              />
            </DisclosureButton>
            <Transition
              enter="transition duration-200 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-100 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <DisclosurePanel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                {children}
              </DisclosurePanel>
            </Transition>
          </>
        )}
      </Disclosure>
    </div>
  );
}
